const home = {
  hero_badge: 'Plateforme de tourisme de santé en Turquie',
  hero_title_1: 'Retrouvez',
  hero_title_2: 'la Santé',
  hero_title_3: 'en Turquie',
  hero_subtitle: 'Découvrez les établissements de santé accrédités de Turquie pour les patients venant de l\'étranger. Planifiez votre voyage vous-même ou confiez toute l\'organisation à une agence intermédiaire.',
  hero_stat_institutions: 'Établissements accrédités',
  hero_stat_patients: 'Patients satisfaits',
  hero_stat_doctors: 'Médecins experts',
  hero_stat_countries: 'Pays',
  hero_accreditation_label: 'Accréditation:',
  hero_search_title: 'Rechercher un traitement',
  hero_step1_label: 'Type de traitement',
  hero_step1_placeholder: 'Saisir ou sélectionner un traitement...',
  hero_step2_label: 'Préférence d\'organisation',
  hero_self_organize: 'Je peux organiser le voyage moi-même',
  hero_agency_organize: 'Qu\'une agence organise mon hôpital et mon voyage',
  hero_step3_agency: 'Agence intermédiaire',
  hero_step3_institution: 'Établissement de santé',
  hero_step3_optional: '(optionnel)',
  hero_all_agencies: 'Voir toutes les agences',
  hero_all_institutions: 'Voir tous les établissements',
  hero_city_label: 'Ville',
  hero_all_cities: 'Toutes les villes',
  hero_search_agencies: 'Explorer les agences',
  hero_search_institutions: 'Explorer les établissements de santé',
  hero_trust_note: 'Tous les établissements sont approuvés par le ministère de la Santé de la République de Turquie',

  steps_title: '3 étapes pour utiliser la plateforme',
  steps_subtitle: 'Trouver le bon établissement de santé est maintenant beaucoup plus facile',
  step1_number: 'Étape 1',
  step1_title: 'S\'inscrire gratuitement',
  step1_desc: 'Inscrivez-vous gratuitement sur la plateforme et accédez instantanément à toutes les fonctionnalités',
  step2_number: 'Étape 2',
  step2_title: 'Parcourir les établissements',
  step2_desc: 'Comparez les établissements de santé accrédités, examinez les médecins et les services',
  step3_number: 'Étape 3',
  step3_title: 'Envoyer une demande de rappel',
  step3_desc: 'Envoyez une demande de rappel à l\'établissement choisi, ils vous appelleront dans votre langue',

  treatment_badge: 'Domaines de traitement',
  treatment_title: 'Traitements les plus',
  treatment_title_highlight: 'populaires en Turquie',
  treatment_subtitle: 'Des milliers de patients internationaux choisissent la Turquie chaque année. Découvrez les établissements accrédités dans les domaines de traitement ci-dessous.',
  treatment_view_institutions: 'Voir les établissements',
  treatment_view_all: 'Voir tous les domaines de traitement',

  institutions_title: 'Établissements',
  institutions_title_highlight: 'de santé',
  institutions_subtitle: 'Trouvez le plus adapté parmi les établissements de santé approuvés',
  institutions_view_all: 'Voir tous les établissements',
  institutions_empty: 'Aucun établissement approuvé pour l\'instant.',
  agencies_badge: 'Organisation & Services de voyage',
  agencies_title: 'Agences de',
  agencies_title_highlight: 'Tourisme de Santé',
  agencies_subtitle: 'Agences qui organisent votre service de santé avec vos besoins de voyage, d\'hébergement et de tourisme',
  agencies_view_all: 'Voir toutes les agences',
  agencies_empty_title: 'Pas encore d\'agences',
  agencies_empty_desc: 'Les agences seront bientôt listées.',
  agency_label: 'Agence',
  consultation_available: 'Demande de consultation possible',
  service_flight: 'Vol & Transfert',
  service_hotel: 'Réservation d\'hôtel',
  service_tour: 'Tour touristique',
  service_translation: 'Traduction',
  service_vip: 'Accueil VIP',

  why_title: 'Pourquoi',
  why_title_highlight: 'Nous choisir?',
  why_subtitle: 'Votre guide de confiance pour les patients internationaux cherchant des soins de santé en Turquie',
  why_stat_institutions: 'Établissements accrédités',
  why_stat_treatments: 'Domaines de traitement',
  why_stat_countries: 'Pays',
  why_stat_satisfaction: 'Satisfaction des patients',
  why_feature1_title: 'Établissements accrédités',
  why_feature1_desc: 'Tous les établissements de santé sur la plateforme sont des établissements vérifiés avec accréditation JCI, ISO ou du ministère de la Santé de Turquie.',
  why_feature2_title: 'Support multilingue',
  why_feature2_desc: 'Filtrez facilement les établissements offrant un support de communication en arabe, anglais, russe et plus de langues.',
  why_feature3_title: 'Comparaison détaillée',
  why_feature3_desc: 'Comparez les établissements côte à côte selon leurs services, médecins, emplacements et avis des patients.',
  why_feature4_title: 'Demande de rappel',
  why_feature4_desc: 'Envoyez directement une demande de rappel à l\'établissement qui vous plaît. L\'établissement vous appellera avec support linguistique.',
  why_feature5_title: 'Coût abordable',
  why_feature5_desc: 'Bénéficiez de soins de santé de classe mondiale à des prix 50-70% inférieurs à ceux de l\'Europe et des États-Unis.',
  why_feature6_title: 'Emplacement & Transport',
  why_feature6_desc: 'Découvrez des établissements dans toutes les villes de Turquie, notamment Istanbul, Ankara, Izmir et Antalya.',

  inst_approved_badge: 'Approuvé',
  inst_explore: 'Explorer',
  inst_doctor_count: '{{count}} Médecin',
  inst_no_approved: 'Aucun établissement approuvé pour l\'instant.',
  agencies_service_badge: 'Agence de tourisme de santé',
  agencies_consult: 'Demande de consultation possible',
  agencies_explore: 'Explorer',

  process_badge: 'Étape par étape',
  process_title: 'Processus',
  process_title_highlight: 'FIV',
  process_subtitle: 'Apprenez chaque étape du traitement FIV de manière compréhensible',
  process_step_label: 'Étape {{num}}',
  process_step1_title: 'Pré-évaluation',
  process_step1_desc: 'Un plan de traitement est créé avec un examen détaillé, des tests hormonaux et une échographie.',
  process_step2_title: 'Stimulation ovarienne',
  process_step2_desc: 'Les ovaires sont stimulés avec des médicaments hormonaux et le développement des ovules est surveillé.',
  process_step3_title: 'Récupération des ovules',
  process_step3_desc: 'Les ovules matures sont collectés sous légère anesthésie.',
  process_step4_title: 'Fécondation',
  process_step4_desc: 'Les cellules ovulaires et spermatiques sont combinées en laboratoire.',
  process_step5_title: 'Développement embryonnaire',
  process_step5_desc: 'Les embryons formés sont développés en laboratoire pendant 3-5 jours.',
  process_step6_title: 'Transfert d\'embryon',
  process_step6_desc: 'L\'embryon de la meilleure qualité est placé dans l\'utérus et un test de grossesse est attendu.',

  explore_badge: 'Découvrir la Turquie',
  explore_title: 'Découvrez',
  explore_title_highlight: 'la Turquie',
  explore_subtitle: 'Ne manquez pas l\'occasion d\'explorer ce beau pays en venant en Turquie pour votre traitement.',
  explore_destinations: 'Destinations',
  explore_culture: 'Culture & Vie',
  explore_about_title: 'À propos de la Turquie',
  explore_about_subtitle: 'Villes, Destinations & Infos pratiques',
  explore_about_desc: 'La péninsule historique d\'Istanbul, la côte égéenne d\'Izmir, les eaux turquoise d\'Antalya et plus encore. Découvrez les plus belles destinations de Turquie.',
  explore_about_highlights: 'Istanbul,Izmir,Antalya,Cappadoce',
  explore_culture_title: 'Culture en Turquie',
  explore_culture_subtitle: 'Étiquette, Cuisine & Traditions',
  explore_culture_desc: 'Hospitalité turque, culture du thé, cuisine délicieuse et riches traditions. Tout ce que vous devez savoir avant de venir en Turquie.',
  explore_culture_highlights: 'Cuisine turque,Étiquette,Traditions,Vie sociale',
  explore_cta: 'Explorer',
  explore_stat1: '81 Provinces, Innombrables Destinations',
  explore_stat2: 'Riche cuisine turque',
  explore_stat3: '10 000 ans d\'histoire',

  faq_badge: 'Bibliothèque de connaissances',
  faq_title: 'Questions',
  faq_title_highlight: 'fréquentes',
  faq_subtitle: 'Questions curieuses sur le processus FIV',
  faq_q1: 'Qu\'est-ce que le traitement FIV et comment fonctionne-t-il?',
  faq_a1: 'La FIV (Fécondation In Vitro) est le processus de combinaison de cellules ovulaires et spermatiques en laboratoire et de placement de l\'embryon résultant dans l\'utérus de la mère. Le processus de traitement comprend la thérapie hormonale, la récupération des ovules, la fécondation et le transfert d\'embryon.',
  faq_q2: 'Combien de temps dure le traitement FIV?',
  faq_a2: 'Un cycle de traitement FIV dure en moyenne 4-6 semaines. Cette période couvre la préparation, la thérapie hormonale, la récupération des ovules et le transfert d\'embryon.',
  faq_q3: 'Quel est le taux de succès du traitement FIV?',
  faq_a3: 'Le taux de succès dépend de facteurs tels que l\'âge, la qualité des ovules, la qualité du sperme et l\'état de santé général. Le taux de succès est d\'environ 40-50% pour les femmes de moins de 35 ans et diminue avec l\'âge.',
  faq_q4: 'Le traitement FIV est-il douloureux?',
  faq_a4: 'La majeure partie du processus de traitement est indolore. La récupération des ovules est effectuée sous légère anesthésie et l\'inconfort est minimal. Le transfert d\'embryon est une procédure indolore.',
  faq_q5: 'Y a-t-il une limite d\'âge pour le traitement FIV?',
  faq_a5: 'En Turquie, la limite d\'âge légale pour le traitement FIV est de 18-49 ans pour les femmes et 18-60 ans pour les hommes. Puisque le taux de succès diminue avec l\'âge, il est plus avantageux de commencer le traitement surtout avant 35 ans.',
  faq_q6: 'Quel est le coût du traitement FIV?',
  faq_a6: 'Le coût varie selon le centre choisi, le protocole de traitement et l\'utilisation de médicaments. En Turquie, il varie en moyenne entre 15 000 et 30 000 TL. Certaines assurances maladie privées peuvent fournir une couverture partielle.',

  // Services de traitement
  treat_sac_ekimi_title: 'Greffe de cheveux',
  treat_sac_ekimi_subtitle: 'Technique FUE / DHI',
  treat_sac_ekimi_desc: 'L\'un des services de tourisme de santé les plus populaires au monde. Résultats permanents et naturels.',
  treat_sac_ekimi_tag: 'Le plus populaire',
  treat_dis_tedavisi_title: 'Traitement dentaire',
  treat_dis_tedavisi_subtitle: 'Implant / Facette / Zircone',
  treat_dis_tedavisi_desc: 'La Turquie est la destination la plus prisée d\'Europe pour la dentisterie esthétique et l\'implantologie.',
  treat_dis_tedavisi_tag: 'Très demandé',
  treat_goz_ameliyati_title: 'Chirurgie oculaire',
  treat_goz_ameliyati_subtitle: 'LASIK / LASEK / Lentille',
  treat_goz_ameliyati_desc: 'Solutions visuelles permanentes avec des cliniques spécialisées en chirurgie laser et lentilles intraoculaires.',
  treat_goz_ameliyati_tag: '',
  treat_estetik_cerrahi_title: 'Chirurgie esthétique',
  treat_estetik_cerrahi_subtitle: 'Rhinoplastie / Liposuccion / BBL',
  treat_estetik_cerrahi_desc: 'Opérations sûres et de qualité avec des spécialistes expérimentés en chirurgie plastique et esthétique.',
  treat_estetik_cerrahi_tag: 'Forte demande',
  treat_ortopedi_title: 'Orthopédie & Traumatologie',
  treat_ortopedi_subtitle: 'Genou / Hanche / Colonne',
  treat_ortopedi_desc: 'Centres orthopédiques experts en remplacement articulaire, chirurgie de la colonne et blessures sportives.',
  treat_ortopedi_tag: '',
  treat_tup_bebek_title: 'Traitement FIV',
  treat_tup_bebek_subtitle: 'FIV / ICSI / PGT',
  treat_tup_bebek_desc: 'Réalisez votre rêve de fonder une famille avec les centres FIV accrédités de Turquie.',
  treat_tup_bebek_tag: '',
  treat_kardiyoloji_title: 'Cardiologie',
  treat_kardiyoloji_subtitle: 'Chirurgie cardiaque / Angiographie',
  treat_kardiyoloji_desc: 'Centres de cardiologie offrant un service de classe mondiale dans le traitement des maladies cardiovasculaires.',
  treat_kardiyoloji_tag: '',
  treat_onkoloji_title: 'Oncologie',
  treat_onkoloji_subtitle: 'Traitement du cancer / Radiothérapie',
  treat_onkoloji_desc: 'Un processus plein d\'espoir avec des centres d\'oncologie utilisant les méthodes les plus récentes.',
  treat_onkoloji_tag: '',
  treat_obezite_title: 'Chirurgie de l\'obésité',
  treat_obezite_subtitle: 'Sleeve gastrectomie / Bypass',
  treat_obezite_desc: 'Faites un pas vers une vie saine avec des équipes spécialisées en chirurgie bariatrique et métabolique.',
  treat_obezite_tag: '',
  treat_checkup_title: 'Bilan de santé',
  treat_checkup_subtitle: 'Dépistage de santé complet',
  treat_checkup_desc: 'Protégez votre santé avec des packages de dépistage précoce et de bilan de santé complet.',
  treat_checkup_tag: '',
  treat_noroloji_title: 'Neurologie & Neurochirurgie',
  treat_noroloji_subtitle: 'Cerveau / Système nerveux',
  treat_noroloji_desc: 'Traitement complet avec des centres spécialisés en maladies neurologiques et neurochirurgie.',
  treat_noroloji_tag: '',
  treat_uroloji_title: 'Urologie',
  treat_uroloji_subtitle: 'Rein / Vessie / Prostate',
  treat_uroloji_desc: 'Solutions sûres avec des cliniques spécialisées dans le diagnostic et le traitement des maladies urologiques.',
  treat_uroloji_tag: '',
  treat_dermatoloji_title: 'Dermatologie',
  treat_dermatoloji_subtitle: 'Peau / Laser / Esthétique',
  treat_dermatoloji_desc: 'Peau saine avec des cliniques spécialisées en maladies cutanées et dermatologie esthétique.',
  treat_dermatoloji_tag: '',
  treat_fizik_tedavi_title: 'Kinésithérapie',
  treat_fizik_tedavi_subtitle: 'Rééducation / Physiothérapie',
  treat_fizik_tedavi_desc: 'Rétablissement rapide avec des centres spécialisés en kinésithérapie et rééducation.',
  treat_fizik_tedavi_tag: '',
  treat_organ_nakli_title: 'Greffe d\'organe',
  treat_organ_nakli_subtitle: 'Rein / Foie / Cœur',
  treat_organ_nakli_desc: 'Une nouvelle vie avec des centres de transplantation expérimentés.',
  treat_organ_nakli_tag: '',

  cta_badge: 'Pour les établissements',
  cta_title: 'Ajoutez votre établissement de santé',
  cta_title_highlight: 'à la plateforme',
  cta_subtitle: 'Atteignez plus de patients. Faites la promotion de votre établissement avec un abonnement gratuit ou Pro, recevez des demandes de consultation et renforcez votre présence en ligne.',
  cta_register: 'Créer un compte établissement',
  cta_more_info: 'Plus d\'informations',
  cta_stat_centers: 'Centres enregistrés',
  cta_stat_consultations: 'Demandes de consultation',
  cta_stat_completed: 'Consultations terminées',
  cta_stat_cities: 'Villes',
};

export default home;
